import { Typography } from '@mui/material';
import LegalPage from '../../components/common/LegalPage';

// Content from New Website.docx, "Page Title 'Security Statement'".
export default function SecurityStatement() {
  return (
    <LegalPage title="How Cherry Creek Mortgage, LLC Protects You">
      <Typography variant="body1">
        We value you as a customer and make it a top priority to ensure your visit to our website is secure,
        reliable, and helpful. Cherry Creek Mortgage, LLC uses a variety of administrative, technical, and
        physical safeguards designed to protect your personal information when you interact with us online.
      </Typography>

      <Typography variant="h5">Security Measures We Use</Typography>
      <Typography variant="body1">To help protect your personal information, we employ industry-standard security practices, including:</Typography>
      <Typography variant="body1" component="ul">
        <li>Antivirus and malware protection to detect and prevent malicious software from accessing our systems</li>
        <li>Firewalls to block unauthorized access to our networks</li>
        <li>
          Encryption technologies, such as Secure Sockets Layer (SSL), to help ensure information remains
          confidential during transmission
        </li>
      </Typography>
      <Typography variant="body1">Data transmitted through our website is protected in the following key ways:</Typography>
      <Typography variant="body1" component="ul">
        <li>
          <strong>Authentication</strong> – Verifies that we are communicating with the intended user and helps
          prevent impersonation by unauthorized individuals or systems
        </li>
        <li>
          <strong>Encryption</strong> – Converts data into a secure format that can be read only by authorized
          parties, preventing unauthorized access
        </li>
      </Typography>

      <Typography variant="h5">Information Collected During Your Visit</Typography>
      <Typography variant="body1">Our websites collect limited information during your visit. This may include:</Typography>
      <Typography variant="body1" component="ul">
        <li>Use of cookies or similar technologies to support security, site navigation, and personalization</li>
        <li>Technical and navigational information such as browser type, IP address, and pages visited</li>
      </Typography>
      <Typography variant="body1">
        Cookies used on our website do not identify you by name or by account number. This information may be used
        to:
      </Typography>
      <Typography variant="body1" component="ul">
        <li>Identify and resolve compatibility or performance issues</li>
        <li>Improve website functionality and user experience</li>
        <li>Help maintain website security</li>
      </Typography>
      <Typography variant="body1">For additional details on data collection and use, please review our Privacy Policy.</Typography>

      <Typography variant="h5">How You Can Help Protect Your Information</Typography>
      <Typography variant="body1">
        <strong>Protect Yourself from Phishing.</strong> Phishing scams attempt to impersonate trusted
        organizations to trick individuals into providing sensitive information. You can reduce your risk by:
      </Typography>
      <Typography variant="body1" component="ul">
        <li>Using caution when opening email attachments or clicking links</li>
        <li>Hovering over links to view the full web address before clicking</li>
        <li>Watching for generic greetings or messages that lack details the sender should already know</li>
      </Typography>

      <Typography variant="body1">
        <strong>Prevent Mortgage-Related Scams.</strong> Fraudsters may request personal or financial information
        or ask for funds to be sent by wire or other urgent methods. Before taking action:
      </Typography>
      <Typography variant="body1" component="ul">
        <li>Verify requests directly with known, trusted contacts involved in your transaction</li>
        <li>Do not rely solely on email or unsolicited communication</li>
      </Typography>

      <Typography variant="body1">
        <strong>When in Doubt, Place a Call.</strong> Scammers often rely on urgency and fear to pressure
        individuals into acting quickly. If something feels suspicious or unexpected:
      </Typography>
      <Typography variant="body1" component="ul">
        <li>Pause before responding</li>
        <li>Contact the company or professional involved using a verified phone number</li>
        <li>Confirm that the communication is legitimate</li>
      </Typography>

      <Typography variant="h5">Cybersecurity Awareness</Typography>
      <Typography variant="body1">
        Cherry Creek Mortgage, LLC encourages customers to stay informed about online safety and cybersecurity best
        practices. The U.S. Department of Homeland Security&rsquo;s &ldquo;Stop.Think.Connect.&rdquo; campaign is a
        nationwide public awareness initiative designed to help individuals recognize cyber threats and take
        simple steps to protect themselves online. Cybersecurity is a shared responsibility. When individuals and
        organizations take proactive steps to stay informed and vigilant, the online experience becomes safer for
        everyone. Additional information about the campaign is available through the Department of Homeland
        Security.
      </Typography>
    </LegalPage>
  );
}
